// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"styles_itemContainer__TWvS9","item_text":"styles_item_text__4c19N"};